module.exports = __webpack_public_path__ + "img/6X4.51184e93.png";